import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PropTypes from "prop-types";
import { Icon } from "MODULES/shared/components";

export default function IconReceived({ placement }) {
  const tooltip = <Tooltip>{"Received"}</Tooltip>;

  return (
    <OverlayTrigger placement={placement} overlay={tooltip}>
      <span className="text-muted">
        <Icon name="cloud-download" />
      </span>
    </OverlayTrigger>
  );
}

IconReceived.defaultProps = {
  placement: "top"
};

IconReceived.propTypes = {
  placement: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/IconReceived/IconReceived.jsx